import React from "react";
import ProviderListItem from "../../components/provider/ProviderList/ProviderListItem";
import {Box} from "@mui/material";
import {useParams} from "react-router";
import {useTitle} from 'react-use';
import { t } from "@lingui/core/macro";

const ProviderListPage = ()  => {

    useTitle(t`List Provider`);
    
    const allQueries = useParams()
    const query = Object.fromEntries(
        Object.entries(allQueries).filter(([key]) => key.endsWith("Id"))
    )
    
    return (
        <Box>
            <ProviderListItem showAdd={true} {...query} />
        </Box>
    )
}

export default ProviderListPage;
